








import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IBrandGateway } from "@/models/gateways";
import {
  PaymentMethodType,
  SelectedPaymentMethodGatewayMobile
} from "@/models/selectPaymentMethod";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-phone-select": () =>
      import("@/components/app/global/fields/clientPhoneSelect.vue")
  }
})
export default class MobileGateway extends Mixins(HasValidation) {
  // Props
  @Prop({ required: true })
  public clientId!: IClient["id"];
  @Prop({ required: true })
  public value;
  @Prop({ required: true })
  public brandGateway!: IBrandGateway;
  public phone = "";

  public get mobileGateway(): SelectedPaymentMethodGatewayMobile {
    return {
      type: PaymentMethodType.GATEWAY_MOBILE,
      data: {
        payer: this.phone,
        gateway_id: this.brandGateway.gateway_id
      }
    };
  }

  @Watch("phone", { immediate: true })
  public formChanged() {
    this.$emit(
      "input",
      this.$_.isEmpty(this.phone) ? null : this.mobileGateway
    );
  }
}
